import { AxiosResponse } from "axios";
import { toast } from "react-toastify";
import useLang from "Shared/hooks/useLanguage";
import { useLocation } from "react-router-dom";
import ReportDisclaimerGrid from "./ReporyDisclaimer";
import React, { useEffect, useRef, useState } from "react";
import { RouteSlice } from "../../../Utils/Compendium/RouteSlicer";
import { NavigatorsArray } from "../../../Utils/Compendium/NavigatorsDetail";
import {
  getReportDisclaimer,
  ReportDisclaimerSave,
  DisclaimerStatus,
  ReportDisclaimerDelete,
} from "Services/Compendium/ReportDisclaimer";

interface PanelSetup {
  value: number | string;
  label: string;
}
const ReportDisclaimer = () => {
  const { t } = useLang();

  const initialSearchRequestObj = {
    reqTypeName: "",
    panelName: "",
  };

  //============================================================================================
  //====================================  PAGINATION START =====================================
  //============================================================================================
  const [request, setRequest] = useState(false);
  const [curPage, setCurPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [total, setTotal] = useState<number>(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumbers, setPageNumbers] = useState<number[]>([]);
  const nextPage = () => {
    if (curPage < Math.ceil(total / pageSize)) {
      setCurPage(curPage + 1);
    }
  };
  const showPage = (i: number) => {
    setCurPage(i);
  };
  const prevPage = () => {
    if (curPage > 1) {
      setCurPage(curPage - 1);
    }
  };
  //============================================================================================
  //====================================  PAGINATION END =======================================
  //============================================================================================
  const [selectedPanels, setSelectedPanels] = useState<any>([]);
  const [reportDisclaimerData, setReportDisclaimerData] = useState([]);
  const [values, setValues] = useState<any>({
    id: 0,
    reqTypeId: 0,
    reqTypeName: "",
    panelId: 0,
    panelName: "",
    isActive: true,
    disclaimer: "",
  });

  const [check, setCheck] = useState(false);
  const [panels, setPanels] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [sports2, setSports2] = useState<any>([]);
  const [openModal, setOpenModal] = useState(false);
  const [editGridHeader, setEditGridHeader] = useState(false);
  const [disableSavebutton, setDisableSaveButton] = useState(false);
  const [disableDeletebutton, setDisableDeleteButton] = useState(false);
  const [triggerSearchData, setTriggerSearchData] = useState(false);
  const [PanelSetupList, setPanelSetupList] = useState<PanelSetup[]>([]);
  const [searchRequest, setSearchRequest] = useState<any>(
    initialSearchRequestObj
  );

  const { pathname } = useLocation();
  const updatedNavigatorsArray = RouteSlice(pathname, NavigatorsArray);

  const loadData = (reset: boolean) => {
    setLoading(true);

    if (reset) {
      setSearchRequest(initialSearchRequestObj);
    }
    const trimmedSearchRequest = Object.fromEntries(
      Object.entries(searchRequest).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );
    getReportDisclaimer({
      pageNumber: curPage,
      pageSize: pageSize,
      queryModel: reset ? initialSearchRequestObj : trimmedSearchRequest,
      sortColumn: reset ? initialSorting.sortColumn : sort?.sortColumn,
      sortDirection: reset ? initialSorting.sortDirection : sort?.sortDirection,
    })
      .then((res: AxiosResponse) => {
        setReportDisclaimerData(res?.data?.result);
        setTotal(res?.data?.totalRecord);
        setLoading(false);
      })
      .catch((err: any) => {
        console.trace(err);
        setLoading(false);
      });
  };
  ////////////-----------------Sorting-------------------///////////////////
  const initialSorting = {
    sortColumn: "id",
    sortDirection: "desc",
  };
  const [sort, setSorting] = useState<any>(initialSorting);
  const searchRef = useRef<any>(null);

  const handleSort = async (columnName: any) => {
    searchRef.current.id = searchRef.current.id
      ? searchRef.current.id === "asc"
        ? (searchRef.current.id = "desc")
        : (searchRef.current.id = "asc")
      : (searchRef.current.id = "asc");
    sort.sortColumn = columnName;
    sort.sortDirection = searchRef.current.id;
    setSorting((preVal: any) => {
      return {
        ...preVal,
        sortingOrder: searchRef?.current?.id,
        clickedIconData: columnName,
      };
    });
    loadData(false);
  };

  ////////////-----------------Sorting-------------------///////////////////

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const type = e.target.type;
    const name = e.target.name;
    const value = e.target.value;
    if (type === "checkbox") {
      if (name === "isActive") {
        setValues((preVal: any) => {
          return {
            ...preVal,
            isActive: e.target.checked,
          };
        });
      }
    } else {
      setValues((preVal: any) => {
        return {
          ...preVal,
          [name]: value,
        };
      });
    }
  };

  const statusChange = async (id: number, status: boolean) => {
    await DisclaimerStatus(id, status)
      .then((res: AxiosResponse) => {
        if (res?.data?.httpStatusCode === 200) {
          toast.success(t(res?.data?.message));
          setOpenModal(false);
          loadData(true);
        }
      })
      .catch((err: any) => console.error(err));
  };

  const DeleteReportDisclaimerById = async (id: number) => {
    setCheck(true);
    setDisableDeleteButton(true);
    await ReportDisclaimerDelete(id)
      .then((res: AxiosResponse) => {
        if (res?.data?.httpStatusCode === 200) {
          toast.success(t(res?.data?.message));
          setDisableDeleteButton(false);
          setOpenModal(false);
          loadData(true);
          setCheck(false);
        }
      })
      .catch(() => {
        setCheck(false);
      });
  };

  //===================================  SECTION ERRORS====================
  const [errors, setErrors] = useState({
    requisitionError: "",
    disclaimer: "",
  });

  const validateForm = () => {
    let formIsValid = true;
    const newErrors: any = {};

    if (!values.reqTypeId) {
      newErrors.requisitionError = t("Please select a requisition Type");
      formIsValid = false;
    }
    if (!values.disclaimer) {
      newErrors.disclaimer = t("Disclaimer Is Required");
      formIsValid = false;
    }

    setErrors(newErrors);

    return formIsValid;
  };

  const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!validateForm()) return;
    setRequest(true);
    setDisableSaveButton(true);
    const objToSend = {
      id: values.id || 0,
      reqTypeId: values.reqTypeId,
      reqTypeName: values.reqTypeName,
      panelId: values.panelId,
      panelName: values.panelName,
      isActive: values.isActive,
      disclaimer: values.disclaimer,
    };
    ReportDisclaimerSave(objToSend)
      .then((res: AxiosResponse) => {
        if (res?.data?.httpStatusCode === 200) {
          toast.success(t(res?.data?.message));
          setDisableSaveButton(false);
          setOpenModal(false);
          loadData(true);
          setRequest(false);
          setEditGridHeader(false);
          setValues({
            reqTypeId: 0,
            panelId: 0,
            disclaimer: "",
            isActive: true,
          });
          setSelectedPanels([]);
          setSports2([]);
        } else if (res?.data?.httpStatusCode === 400) {
          toast.error(t(res?.data?.message));
          setDisableSaveButton(false);
          setRequest(false);
        }
      })
      .catch((err: any) => {
        console.error(t("Error submitting form:"), err);
        setRequest(false);
      });
  };

  const Edit = (item: any) => {
    setOpenModal(true);
    setValues((preVal: any) => {
      return {
        ...preVal,
        id: item.id || 0,
        reqTypeId: item.reqTypeId,
        reqTypeName: item.reqTypeName,
        panelId: item.panelId,
        panelName: item.panelName,
        isActive: item.isActive,
        disclaimer: item.disclaimer,
      };
    });
    setEditGridHeader(true);
    setErrors((pre: any) => {
      return {
        ...pre,
        disclaimer: "",
        requisitionError: "",
      };
    });
  };

  const handleOpen = () => {
    setValues((preVal: any) => {
      return {
        ...preVal,
        id: 0,
        reqTypeId: 0,
        panels: [],
        panelId: 0,
        isActive: true,
      };
    });
    setErrors((pre: any) => {
      return {
        ...pre,
        disclaimer: "",
        requisitionError: "",
      };
    });
    setEditGridHeader(false);
    setOpenModal(true);
  };

  useEffect(() => {
    loadData(false);
  }, [pageSize, curPage, triggerSearchData]);

  useEffect(() => {
    setTotalPages(Math.ceil(total / pageSize));
    const pgNumbers = [];
    for (let i = curPage - 2; i <= curPage + 2; i++) {
      if (i > 0 && i <= totalPages) {
        pgNumbers.push(i);
      }
    }
    setPageNumbers(pgNumbers);
  }, [total, curPage, pageSize, totalPages]);

  useEffect(() => {
    loadData(true);
  }, []);
  return (
    <>
      <ReportDisclaimerGrid
        sort={sort}
        Edit={Edit}
        check={check}
        total={total}
        errors={errors}
        panels={panels}
        values={values}
        sports2={sports2}
        curPage={curPage}
        loading={loading}
        request={request}
        nextPage={nextPage}
        showPage={showPage}
        prevPage={prevPage}
        loadData={loadData}
        pageSize={pageSize}
        setErrors={setErrors}
        searchRef={searchRef}
        setPanels={setPanels}
        openModal={openModal}
        setValues={setValues}
        handleOpen={handleOpen}
        setRequest={setRequest}
        setSports2={setSports2}
        handleSort={handleSort}
        setSorting={setSorting}
        setCurPage={setCurPage}
        totalPages={totalPages}
        pageNumbers={pageNumbers}
        setPageSize={setPageSize}
        statusChange={statusChange}
        handleSubmit={handleSubmit}
        setOpenModal={setOpenModal}
        searchRequest={searchRequest}
        editGridHeader={editGridHeader}
        PanelSetupList={PanelSetupList}
        handleOnChange={handleOnChange}
        selectedPanels={selectedPanels}
        setSearchRequest={setSearchRequest}
        setPanelSetupList={setPanelSetupList}
        disableSavebutton={disableSavebutton}
        setEditGridHeader={setEditGridHeader}
        setSelectedPanels={setSelectedPanels}
        NavigatorsArray={updatedNavigatorsArray}
        disableDeletebutton={disableDeletebutton}
        reportDisclaimerData={reportDisclaimerData}
        setTriggerSearchData={setTriggerSearchData}
        initialSearchRequestObj={initialSearchRequestObj}
        DeleteReportDisclaimerById={DeleteReportDisclaimerById}
        modalheader={
          editGridHeader
            ? t("Edit Report Disclaimer")
            : t("Add Report Disclaimer")
        }
      />
    </>
  );
};
export default ReportDisclaimer;
